import { render, staticRenderFns } from "./EmployeeExportYearlyAttendancePage.vue?vue&type=template&id=10b4a805&scoped=true&"
import script from "./EmployeeExportYearlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./EmployeeExportYearlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4a805",
  null
  
)

export default component.exports